import React, { useState } from "react";
import { Modal, ModalFooter } from "react-bootstrap";
import { Button, Input } from "../../../components";
import {
  BookingRefund,
  CancelCourtBooking,
  CollectCash,
} from "../../../utilities/api/courtBooking";
import { toast } from "react-toastify";
import {
  CancelAssociateBooking,
  CollectAssociateInvoicePayment,
  RefundAssociateBooking,
} from "../../../utilities/api/associateBooking";

const ConfirmCancelModal = (props: any) => {
  const [remark, setRemark] = useState("");
  const { show, handleClose, name, id, GetData } = props;

  const handleSubmit = async () => {
    let payload = { remarkText: remark };
    let result;
    if (name === "Cancel Booking") {
      result = await CancelCourtBooking(id, payload);
    } else if (name === "Cancel Associate Booking") {
      result = await CancelAssociateBooking(id, payload);
    } else if (name === "Collect Cash") {
      result = await CollectCash(id, payload);
    } else if (name === "Associate Collect Cash") {
      result = await CollectAssociateInvoicePayment(
        id?.bookingId,
        id?.invoiceId
      );
    } else if (name === "Refund Court Booking") {
      result = await BookingRefund(id, payload);
    } else if (name === "Refund Associate Booking") {
      result = await RefundAssociateBooking(id, payload);
    }

    if (result?.status === 200) {
      handleClose();
      GetData();
      toast.success(result?.data.message);
    } else {
      toast.error(result?.response.data.message);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      {name === "Collect_Cash" || name === "Associate Collect Cash" ? (
        <>
          <Modal.Header className="border-0 pb-0 pb-2" closeButton>
            <Modal.Title id="contained-modal-title-vcenter fw-semibold">
              Collect Cash
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Are you sure you want to make the status paid?</p>
            <p>
              You will not be able to re-change again the status from Paid to
              Pending
            </p>
            <ModalFooter className="justify-center">
              <div className="">
                <Button
                  onClick={handleSubmit}
                  type="button"
                  bname="Paid"
                  name="paid"
                  id="paid"
                  className="btn btn-primary rounded-1 mt-1 me-3"
                ></Button>
                <Button
                  onClick={handleClose}
                  type="button"
                  bname="Cancel"
                  name="cancel"
                  id="cancel"
                  className="btn btn-light rounded-1 mt-1"
                ></Button>
              </div>
            </ModalFooter>
          </Modal.Body>
        </>
      ) : (
        <>
          <Modal.Header className="border-0 pb-0 pb-2" closeButton>
            <Modal.Title id="contained-modal-title-vcenter fw-semibold">
              Remarks
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Do you want to {name}?</p>
            <div className="mb-3">
              <Input
                onChange={(e: any) => setRemark(e.target.value)}
                type="text"
                className="form-control"
                id="remark"
                name="remark"
                maxLength={200}
              />
              {remark.length < 3 && (
                <span className="error-msg">
                  Remark is Mandatory ( More Than 3 Characters )
                </span>
              )}
              {remark.length >= 3 && remark.length > 200 && (
                <span className="error-msg">
                  Remark should have maximum 199 characters
                </span>
              )}
            </div>
            <ModalFooter className="justify-center">
              <div className="">
                <Button
                  disabled={remark.length < 3 || remark.length > 200}
                  onClick={handleSubmit}
                  type="button"
                  bname="Yes"
                  name="yes"
                  id="yes"
                  className="btn btn-primary rounded-1 mt-1 me-3"
                ></Button>
                <Button
                  onClick={handleClose}
                  type="button"
                  bname="No"
                  name="no"
                  id="no"
                  className="btn btn-light rounded-1 mt-1"
                ></Button>
              </div>
            </ModalFooter>
          </Modal.Body>
        </>
      )}
    </Modal>
  );
};

export { ConfirmCancelModal };
